import {
  ResponsesMonthlyCustomerActivationResponse,
  ResponsesMonthlyPerformanceResponse,
  ResponsesSuitabilityPerformanceResponse,
} from '@genial/services/dist/models';

import { getMonthInfo } from './constants';
import {
  MonthlyHabilitationNormalized,
  MonthlyPerformanceByProfileNormalized,
  MonthlyPerformanceNormalized,
} from './types';

export const normalizeCustomersHabilitationPerformanceData = (
  performanceData?: ResponsesMonthlyPerformanceResponse[] | null
): MonthlyHabilitationNormalized[] => {
  if (!performanceData) {
    return [];
  }

  return performanceData.map((item) => {
    const [month, year] = item.month!.split('/').map(Number);
    const monthInfo = getMonthInfo(month);
    return {
      ...item,
      monthAcronym: monthInfo.monthAcronym,
      habilitationValue: item.enabledAccountsMonth || 0,
      monthName: monthInfo.monthName,
      year,
    };
  });
};

export const normalizeCustomersActivationPerformanceData = (
  performanceData?: ResponsesMonthlyCustomerActivationResponse[] | null
): MonthlyPerformanceNormalized[] => {
  if (!performanceData) {
    return [];
  }

  return performanceData.map((item) => {
    const [month, year] = item.month!.split('/').map(Number);
    const monthInfo = getMonthInfo(month);
    return {
      ...item,
      monthAcronym: monthInfo.monthAcronym,
      activationValue: item.activationAmount || 0,
      monthName: monthInfo.monthName,
      year,
    };
  });
};

const normalizeSuitabilityName = (suitability?: string | null) => {
  const suitabilitiesMap = {
    Conservador: 'conservativeValue',
    Moderado: 'moderateValue',
    Arrojado: 'aggressiveValue',
    'Sem Perfil - Recusa': 'withoutProfileValue',
    'Qualificado/Profissional': 'qualifiedOrProfessionalValue',
  };
  if (!suitability) {
    return 'withoutProfileValue';
  }
  return suitabilitiesMap[suitability] ?? 'withoutProfileValue';
};

export const normalizeCustomersActivationByProfileData = (
  performanceData?: ResponsesSuitabilityPerformanceResponse[] | null
): MonthlyPerformanceByProfileNormalized[] => {
  if (!performanceData) {
    return [];
  }

  const reduced = performanceData.reduce((acc, item) => {
    if (!acc.length) {
      acc.push(
        ...(item.monthlyPerformance?.map((performance) => ({
          month: performance.month,
          [normalizeSuitabilityName(item.suitabilityProfile)]: performance.enabledAccountsMonth,
        })) ?? [])
      );
    }
    acc.forEach((accItem) => {
      const performance = item.monthlyPerformance?.find(
        (monthlyPerformance) => monthlyPerformance.month === accItem.month
      );
      if (performance) {
        accItem[normalizeSuitabilityName(item.suitabilityProfile)] =
          performance.enabledAccountsMonth;
      }
    });
    return acc;
  }, [] as any);

  return reduced.map((item) => {
    const [month, year] = item.month!.split('/').map(Number);
    const monthInfo = getMonthInfo(month);

    return {
      ...item,
      monthAcronym: monthInfo.monthAcronym,
      monthName: monthInfo.monthName,
      year,
    };
  });
};
